
import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';


const images = [
  { src: '/dental/dental1.jpg' },
  { src: '/dental/dental2.jpg' },
  { src: '/dental/dental3.jpg' },
  { src: '/dental/dental4.jpg' },
  { src: '/dental/dental5.jpg' },
];

export default function DentalSlideshowBackground() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="absolute inset-0 w-full h-full z-0 overflow-hidden">
      <AnimatePresence initial={false}>
        {images.map((img, idx) =>
          idx === current ? (
            <motion.img
              key={img.src + '-' + idx}
              src={img.src}
              alt="Dental College Slideshow"
              className="object-cover w-full h-full absolute inset-0 z-10"
              draggable={false}
              initial={{ x: 100, opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: -100, opacity: 0 }}
              transition={{ duration: 0.8, ease: 'easeInOut' }}
              onError={e => {
                (e.target as HTMLImageElement).style.display = 'none';
              }}
            />
          ) : null
        )}
      </AnimatePresence>
      {/* Overlay for darkening and readability */}
      <div className="absolute inset-0 bg-black bg-opacity-30 pointer-events-none" />
    </div>
  );
}
